import React, { useEffect, useState } from 'react'

import { ICON_KIND_LOOKUP } from './components/Icon'

import { User } from './types'
import { Permission } from './types/permissions'
import Useraccess from './views/Useraccess/Useraccess'
import { claimcontactNum, userPermissionRole } from './util/UserPermissionsRole'
import HomeWarranty from './views/Transaction/HomeWarranty'
// import IncompleteOffer from './views/Transaction/Components/IncompleteOffer'
import Maps from './views/IDX/Components/Maps'
import { useDispatch, useSelector } from 'react-redux'
import { claimcount } from './state/actions'
import ViewSimilarProperties from './views/IDX/Util/ViewSimilarProperties'

const Leads = React.lazy(() => import('./views/leads/Leads'))
const UserManagement = React.lazy(() => import('./views/Users/UserTable'))
const UserDetail = React.lazy(() => import('./views/Users/UserManagement'))
const Components = React.lazy(() => import('./views/Components'))
const NewLeads = React.lazy(() => import('./views/NewLeads'))
const Dashboard = React.lazy(() => import('./views/Dashboard'))
const ChangeLog = React.lazy(() => import('./views/ChangeLog'))
const Forbidden = React.lazy(() => import('./views/errors/Forbidden'))
const NotFound = React.lazy(() => import('./views/errors/NotFound'))
const ClaimLead = React.lazy(() => import('./views/leads/Claim'))
const LeadsTable = React.lazy(() => import('./views/leads/LeadsTable'))
const Transaction = React.lazy(() => import('./views/Transaction/Transaction'))
const TransactionDetails = React.lazy(() => import('./views/Transaction/TransactionDetails'))
const Createnewpassword = React.lazy(() => import('./views/IDX/Createnewpassword'))
const VerifyIdentity = React.lazy(() => import('./views/IDX/Components/VerifyIdentity'))
const VerifyPhone = React.lazy(() => import('./views/IDX/Components/VerifyPhone'))
const SingleProduct = React.lazy(() => import('./views/IDX/Components/SingleProduct'))
const Favorites = React.lazy(() => import('./views/IDX/Components/Favourites'))
const Dislikes = React.lazy(() => import('./views/IDX/Components/DislikesList'))
const RecentlyViewed = React.lazy(() => import('./views/IDX/Components/RecentlyViewed'))
const Accounts = React.lazy(() => import('./views/IDX/Components/Account'))
const AccountSettings = React.lazy(() => import('./views/IDX/Components/AccountSetting'))
const Team = React.lazy(() => import('./views/IDX/Components/Team'))
const Profile = React.lazy(() => import('./views/IDX/Components/Profile'))
const SavedList = React.lazy(() => import('./views/IDX/Components/SavedLists'))
const Home = React.lazy(() => import('./views/IDX/Home'))
const savedlistitems = React.lazy(() => import('./views/IDX/Components/SavedListItems'))
const Refferal = React.lazy(() => import('./views/IDX/Components/Reffral'))
const SubmitReferals = React.lazy(() => import('./views/IDX/Components/SubmitReferals'))
const Teamprofile = React.lazy(() => import('./views/IDX/Components/Teamprofile'))
const MyReffral = React.lazy(() => import('./views/IDX/Components/MyReffral'))
const Messages = React.lazy(() => import('./views/IDX/Components/Messages'))
const ComposeNewMessages = React.lazy(() => import('./views/IDX/Components/ComposeNewMessages'))
const ChatView = React.lazy(() => import('./views/IDX/Components/ChatView'))
const DashboardMain = React.lazy(() => import('./views/Transaction/DashboardMain'))
const Mission = React.lazy(() => import('./views/Mission'))
const NewTransaction = React.lazy(() => import('./views/Transaction/NewTransaction'))
const EsignDocuments = React.lazy(() => import('./views/Transaction/EsignDocuments'))
const ClaimTransaction = React.lazy(() => import('./views/Transaction/ClaimTransaction'))
const OfficeExclusive = React.lazy(()=> import('./views/Transaction/Components/OfficeExlusive'))


const routing = () => {
 
  const userpermissionsrole = userPermissionRole();
const claim = claimcontactNum()


  const route = [
    { permissions: [], path: '/', exact: true, name: 'Home', navItem: null },
    { permissions: [], path: '/forbidden', exact: true, name: 'Forbidden', navItem: null, component: Forbidden },
    { permissions: [], path: '/not-found', exact: true, name: 'NotFound', navItem: null, component: NotFound },

    // Dashboard
    // {
    //   permissions: [],
    //   // path: '/leads',
    //   name: 'Dashboard',
    //   component: LeadsTable,
    //   navItem: {
    //     _tag: 'SidebarItem',
    //     name: 'Dashboard',
    //     icon: {
    //      content: `<svg width="60" height="60" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    //       <path d="M4.77148 3.80762H7.60482C7.60482 3.80762 8.10482 3.80762 8.10482 4.30762V8.14095C8.10482 8.14095 8.10482 8.64095 7.60482 8.64095H4.77148C4.77148 8.64095 4.27148 8.64095 4.27148 8.14095V4.30762C4.27148 4.30762 4.27148 3.80762 4.77148 3.80762Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    //       <path d="M4.77148 10.6406H7.60482C7.60482 10.6406 8.10482 10.6406 8.10482 11.1406V12.974C8.10482 12.974 8.10482 13.474 7.60482 13.474H4.77148C4.77148 13.474 4.27148 13.474 4.27148 12.974V11.1406C4.27148 11.1406 4.27148 10.6406 4.77148 10.6406Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    //       <path d="M10.6055 8.64062H13.4388C13.4388 8.64062 13.9388 8.64062 13.9388 9.14063V12.974C13.9388 12.974 13.9388 13.474 13.4388 13.474H10.6055C10.6055 13.474 10.1055 13.474 10.1055 12.974V9.14063C10.1055 9.14063 10.1055 8.64062 10.6055 8.64062Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    //       <path d="M10.6055 3.80762H13.4388C13.4388 3.80762 13.9388 3.80762 13.9388 4.30762V6.14095C13.9388 6.14095 13.9388 6.64095 13.4388 6.64095H10.6055C10.6055 6.64095 10.1055 6.64095 10.1055 6.14095V4.30762C10.1055 4.30762 10.1055 3.80762 10.6055 3.80762Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    //       <path d="M2.60547 1.14062H15.6055C15.6055 1.14062 16.6055 1.14062 16.6055 2.14063V15.1406C16.6055 15.1406 16.6055 16.1406 15.6055 16.1406H2.60547C2.60547 16.1406 1.60547 16.1406 1.60547 15.1406V2.14063C1.60547 2.14063 1.60547 1.14062 2.60547 1.14062Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    //       </svg>
    //       `
  //     },
    //   }
    // },
    { permissions: [], path: '/dashboard', name: 'Dashboard', component: Dashboard, 
    navItem: {
      _tag: 'SidebarItem',
      name: 'Dashboard',
      icon: {
        content: `
        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 18 17" fill="none">
<path d="M4.77148 3.80762H7.60482C7.60482 3.80762 8.10482 3.80762 8.10482 4.30762V8.14095C8.10482 8.14095 8.10482 8.64095 7.60482 8.64095H4.77148C4.77148 8.64095 4.27148 8.64095 4.27148 8.14095V4.30762C4.27148 4.30762 4.27148 3.80762 4.77148 3.80762Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.77148 10.6406H7.60482C7.60482 10.6406 8.10482 10.6406 8.10482 11.1406V12.974C8.10482 12.974 8.10482 13.474 7.60482 13.474H4.77148C4.77148 13.474 4.27148 13.474 4.27148 12.974V11.1406C4.27148 11.1406 4.27148 10.6406 4.77148 10.6406Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.6055 8.64062H13.4388C13.4388 8.64062 13.9388 8.64062 13.9388 9.14063V12.974C13.9388 12.974 13.9388 13.474 13.4388 13.474H10.6055C10.6055 13.474 10.1055 13.474 10.1055 12.974V9.14063C10.1055 9.14063 10.1055 8.64062 10.6055 8.64062Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.6055 3.80762H13.4388C13.4388 3.80762 13.9388 3.80762 13.9388 4.30762V6.14095C13.9388 6.14095 13.9388 6.64095 13.4388 6.64095H10.6055C10.6055 6.64095 10.1055 6.64095 10.1055 6.14095V4.30762C10.1055 4.30762 10.1055 3.80762 10.6055 3.80762Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.60547 1.14062H15.6055C15.6055 1.14062 16.6055 1.14062 16.6055 2.14063V15.1406C16.6055 15.1406 16.6055 16.1406 15.6055 16.1406H2.60547C2.60547 16.1406 1.60547 16.1406 1.60547 15.1406V2.14063C1.60547 2.14063 1.60547 1.14062 2.60547 1.14062Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
        `,
      },
    }

     },
    {
      permissions: (userpermissionsrole?.some((permission) => permission.id === "contacts") === true) ? [] : ['Contacts'],
      path: '/leads',
      name: 'Contacts',
      
      component: LeadsTable,
      navItem: {
        _tag: 'SidebarItem',
        name: 'Contacts',
        icon: {
          content: `<svg width="60" height="60" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.33203 4.33301C4.33203 5.12866 4.6481 5.89172 5.21071 6.45433C5.77332 7.01694 6.53638 7.33301 7.33203 7.33301C8.12768 7.33301 8.89074 7.01694 9.45335 6.45433C10.016 5.89172 10.332 5.12866 10.332 4.33301C10.332 3.53736 10.016 2.7743 9.45335 2.21169C8.89074 1.64908 8.12768 1.33301 7.33203 1.33301C6.53638 1.33301 5.77332 1.64908 5.21071 2.21169C4.6481 2.7743 4.33203 3.53736 4.33203 4.33301Z" stroke="#1E1D1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M1.66602 14.6663C1.66602 13.2519 2.26304 11.8953 3.32574 10.8951C4.38845 9.89491 5.82979 9.33301 7.33268 9.33301C8.83558 9.33301 10.2769 9.89491 11.3396 10.8951C12.4023 11.8953 12.9993 13.2519 12.9993 14.6663" stroke="#1E1D1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          `,
        },
      }
    },


    // start
    {
      permissions: (userpermissionsrole?.some((permission) => permission.id === "unspecified") === true) ? [] : ['Unspecified'],
      path: '/leads/unspecified',
      name: 'Unspecified',
      component: LeadsTable,
      navItem: {
        addLinkClass: 'sub-nav-item with-hide first-nav ',
        _tag: 'SidebarItem',
        name: 'Unspecified',
        hidden: false
      },
    },
    {
      permissions: (userpermissionsrole?.some((permission) => permission.id === "suspects") === true) ? [] : ['Suspects'],
      path: '/leads/suspect',
      name: 'Suspects',
      component: LeadsTable,
      navItem: {
        addLinkClass: 'sub-nav-item with-hide',
        _tag: 'SidebarItem',
        name: 'Suspects',
        hidden: false
      },
    },
    {
      permissions: (userpermissionsrole?.some((permission) => permission.id === "prospects") === true) ? [] : ['Prospects'],
      path: '/leads/prospect',
      name: 'Prospects',
      component: LeadsTable,
      navItem: {
        addLinkClass: 'sub-nav-item with-hide',
        _tag: 'SidebarItem',
        name: 'Prospects',
        hidden: false
      }
    },
    {
      permissions: (userpermissionsrole?.some((permission) => permission.id === "leads") === true) ? [] : ['Leads'],
      path: '/leads/lead',
      name: 'Leads',
      component: LeadsTable,
      navItem: {
        addLinkClass: 'sub-nav-item with-hide',
        _tag: 'SidebarItem',
        name: 'Leads',
        hidden: false
      }
    },
    {
      permissions: (userpermissionsrole?.some((permission) => permission.id === "future") === true) ? [] : ['Future'],
      path: '/leads/future',
      name: 'Future',
      component: LeadsTable,
      navItem: {
        addLinkClass: 'sub-nav-item',
        _tag: 'SidebarItem',
        name: 'Future',
        hidden: false
      }
    },
    {
      permissions: (userpermissionsrole?.some((permission) => permission.id === "clients") === true) ? [] : ['Clients'],
      path: '/leads/client',
      name: 'Clients',
      component: LeadsTable,
      navItem: {
        addLinkClass: 'sub-nav-item',
        _tag: 'SidebarItem',
        name: 'Clients',
        hidden: false
      }
    },
    {
      permissions: (userpermissionsrole?.some((permission) => permission.id === "clientdonotcontact") === true) ? [] : ["Client - Do Not Contact"],
      path: '/leads/client-donotcontact',
      name: 'Client - Do Not Contact ',
      component: LeadsTable,
      navItem: {
        addLinkClass: 'sub-nav-item',
        _tag: 'SidebarItem',
        name: 'Client - Do Not Contact',
        hidden: false
      }
    },
    {
      permissions: (userpermissionsrole?.some((permission) => permission.id === "pastclients") === true) ? [] : ["Past Clients"],
      path: '/leads/past-client',
      name: 'Past Clients',
      component: LeadsTable,
      navItem: {
        addLinkClass: 'sub-nav-item',
        _tag: 'SidebarItem',
        name: 'Past Clients',
        hidden: false
      }
    },
    {
      permissions: (userpermissionsrole?.some((permission) => permission.id === "oldleadsupdated") === true) ? [] : ["Past Client - Updated"],
      path: '/leads/past-client-updated',
      name: 'Past Client - Updated',
      component: LeadsTable,
      navItem: {
        addLinkClass: 'sub-nav-item',
        _tag: 'SidebarItem',
        name: 'Past Client - Updated',
        hidden: false
      }
    },
    {
      permissions: (userpermissionsrole?.some((permission) => permission.id === "pastclientsupdated") === true) ? [] : ["Past Clients - Updated"],
      path: '/leads/past-client-updated',
      name: 'Past Clients - Updated',
      component: LeadsTable,
      navItem: {
        addLinkClass: 'sub-nav-item',
        _tag: 'SidebarItem',
        name: 'Past Clients - Updated',
        hidden: false
      }
    },
    {
      permissions: (userpermissionsrole?.some((permission) => permission.id === "lostclients") === true) ? [] : ["Lost Clients"],
      path: '/leads/lost',
      name: 'Lost Clients',
      component: LeadsTable,
      navItem: {
        addLinkClass: 'sub-nav-item',
        _tag: 'SidebarItem',
        name: 'Lost Clients',
        hidden: false
      }
    },
    {
      permissions: (userpermissionsrole?.some((permission) => permission.id === "lostleads") === true) ? [] : ["Lost Leads"],
      path: '/leads/lost-leads',
      name: 'Lost Leads',
      component: LeadsTable,
      navItem: {
        addLinkClass: 'sub-nav-item',
        _tag: 'SidebarItem',
        name: 'Lost Leads',
        hidden: false
      }
    },
    {
      permissions: (userpermissionsrole?.some((permission) => permission.id === "trashleads") === true) ? [] : ["Trash Leads"],
      path: '/leads/trash-lead',
      name: 'Trash Leads',
      component: LeadsTable,
      navItem: {
        addLinkClass: 'sub-nav-item',
        _tag: 'SidebarItem',
        name: 'Trash Leads',
        hidden: false
      }
    },
    {
      permissions: (userpermissionsrole?.some((permission) => permission.id === "oldleads") === true) ? [] : ["Old Lead"],
      path: '/leads/old-lead',
      name: 'Old Lead',
      component: LeadsTable,
      navItem: {
        addLinkClass: 'sub-nav-item',
        _tag: 'SidebarItem',
        name: 'Old Lead',
        hidden: false
      }
    },
    {
      permissions: (userpermissionsrole?.some((permission) => permission.id === "claimleads") === true) ? [] : ["Claim Leads"],
      path: '/leads/claim-lead',
      name: 'Claim Leads',
      component: LeadsTable,
      navItem: {
        addLinkClass: 'sub-nav-item',
        _tag: 'SidebarItem',
        name: 'Claim Leads',
        hidden: false
      }
    },
    {
      permissions: (userpermissionsrole?.some((permission) => permission.id === "creditrepair") === true) ? [] : ["Credit Repair"],
      path: '/leads/credit-repair',
      name: 'Credit Repair',
      component: LeadsTable,
      navItem: {
        addLinkClass: 'sub-nav-item',
        _tag: 'SidebarItem',
        name: 'Credit Repair',
        hidden: false
      }
    },
    {
      permissions: (userpermissionsrole?.some((permission) => permission.id === "investor") === true) ? [] : ["Investor"],
      path: '/leads/investor',
      name: 'Investor',
      component: LeadsTable,
      navItem: {
        addLinkClass: 'sub-nav-item',
        _tag: 'SidebarItem',
        name: 'Investor',
        hidden: false
      }
    },
    {
      permissions: (userpermissionsrole?.some((permission) => permission.id === "nonresponsive") === true) ? [] : ["Non Responsive"],
      path: '/leads/non-responsive',
      name: 'Non Responsive ',
      component: LeadsTable,
      navItem: {
        addLinkClass: 'sub-nav-item last-nav',
        _tag: 'SidebarItem',
        name: 'Non Responsive',
        hidden: false
      }
    },
    // end


    { permissions: [], path: '/leads/:id', name: 'Lead', component: Leads, navItem: null },
    {
      permissions: (userpermissionsrole?.some((permission) => permission.id === "usermanagement") === true) ? [] : ["usermanagement"],
      path: '/usermanagement',
      name: 'UserManagement',
      component: UserManagement,
      navItem: {
        _tag: 'SidebarItem',
        name: 'User Management',
        icon: 'cil-group',
      }
    },
    { permissions: [], path: '/users/:id', name: 'User', component: UserDetail, navItem: null },
    { permissions: [], path: '/components', name: 'Components', component: Components, navItem: null },
    { permissions: [], path: '/newleads', name: 'NewLeads', component: NewLeads, navItem: null },
 
    { permissions: [], path: '/change-log', name: 'ChangeLog', component: ChangeLog, navItem: null },

    {
      permissions: (userpermissionsrole?.some((permission) => permission.id === "e-sign") === true) ? [] : ['e-sign'],
      path: '/esign', name: 'ChangeLog', component: EsignDocuments, navItem: {
        _tag: 'SidebarItem',
        name: 'E-Sign',
        icon: {
          content: `
        <svg width="65" height="65" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.66174 8.51024L5.95508 11.3389L8.78308 10.6316L13.0257 6.38891L10.9044 4.26758L6.66174 8.51024Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M15.5007 3.91406L16.2073 4.62073C16.3003 4.7136 16.374 4.82386 16.4243 4.94523C16.4746 5.0666 16.5005 5.19669 16.5005 5.32806C16.5005 5.45944 16.4746 5.58953 16.4243 5.71089C16.374 5.83226 16.3003 5.94253 16.2073 6.0354L14 8.24206" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M13.0256 6.38879L15.501 3.91412C15.5939 3.82125 15.6676 3.71099 15.7179 3.58962C15.7682 3.46825 15.7941 3.33816 15.7941 3.20679C15.7941 3.07541 15.7682 2.94532 15.7179 2.82396C15.6676 2.70259 15.5939 2.59232 15.501 2.49945L14.7936 1.79279C14.6061 1.60532 14.3518 1.5 14.0866 1.5C13.8215 1.5 13.5672 1.60532 13.3796 1.79279L10.9043 4.26679" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14.5007 10V12.0853C14.5006 12.2167 14.4747 12.3468 14.4244 12.4682C14.3741 12.5896 14.3003 12.6998 14.2073 12.7927L10.7933 16.2067C10.7005 16.2996 10.5902 16.3734 10.4689 16.4237C10.3475 16.4741 10.2174 16.5 10.086 16.5H2.5C2.23478 16.5 1.98043 16.3946 1.79289 16.2071C1.60536 16.0196 1.5 15.7652 1.5 15.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H10" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10.5 16.41V13.5C10.5 13.2348 10.6054 12.9804 10.7929 12.7929C10.9804 12.6054 11.2348 12.5 11.5 12.5H14.41" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

        `
        },
      }
    },

    {
      permissions: (userpermissionsrole?.some((permission) => permission.id === "userpermissions") === true) ? [] : ["userpermissions"],
      path: '/useraccess',
      name: 'User Permissions',
      component: Useraccess,
      navItem: {
        _tag: 'SidebarItem',
        name: 'User Permissions',
        icon: { content: ICON_KIND_LOOKUP.Permission },
      }
    },
    // {
    //   permissions: (userpermissionsrole?.some((permission) => permission.id === "claimcontact") === true) ? [] : ["claimcontact"],
    //   path: '/claim-leads',
    //   name: 'ClaimLeads',
    //   component: ClaimLead,
    //   navItem: {
    //     _tag: 'SidebarItem',
    //     name: 'Claim Contact',
    //     icon: { content: ICON_KIND_LOOKUP.Handshake },
    //   }
    // },
    {
      permissions: (userpermissionsrole?.some((permission) => permission.id === "claimcontact") === true) ? [] : ["claimcontact"],
      path: '/claim-leads',
      name: 'ClaimLeads',
      component: ClaimLead,
      navItem: {
        _tag: 'SidebarItem',
        name: 'Claim Contact',
        icon: {
          content: `<svg width="60" height="70" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.33203 4.33301C4.33203 5.12866 4.6481 5.89172 5.21071 6.45433C5.77332 7.01694 6.53638 7.33301 7.33203 7.33301C8.12768 7.33301 8.89074 7.01694 9.45335 6.45433C10.016 5.89172 10.332 5.12866 10.332 4.33301C10.332 3.53736 10.016 2.7743 9.45335 2.21169C8.89074 1.64908 8.12768 1.33301 7.33203 1.33301C6.53638 1.33301 5.77332 1.64908 5.21071 2.21169C4.6481 2.7743 4.33203 3.53736 4.33203 4.33301Z" stroke="#1E1D1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M1.66602 14.6663C1.66602 13.2519 2.26304 11.8953 3.32574 10.8951C4.38845 9.89491 5.82979 9.33301 7.33268 9.33301C8.83558 9.33301 10.2769 9.89491 11.3396 10.8951C12.4023 11.8953 12.9993 13.2519 12.9993 14.6663" stroke="#1E1D1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg> 
            `
        },

        badge: {
          text: claim,
          color: 'primary'
        }
      }
    },
    {
      permissions: [],
      path: '/transaction-details',
      name: 'TransactionDetails',
      component: TransactionDetails,
      //   navItem: {
      //     _tag:'SidebarItem',
      //     name:'Transaction Details',
      //     icon:{ content:ICON_KIND_LOOKUP.Handshake },
      //   }
    },
    {
      permissions: (userpermissionsrole?.some((permission) => permission.id === "transaction") === true) ? [] : ["transaction"],
      path: '/dashboardmain',
      name: 'Transactions',
      component: DashboardMain,
      navItem: {
        _tag: 'SidebarItem',
        name: 'Transactions',
        icon: {
          content: `<svg width="62" height="65" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 4H6.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5.5 6.5H9.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5.5 9H9.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5.5 11.5H9.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5.5 14H7.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M13 1.5H14C14.2652 1.5 14.5196 1.60536 14.7071 1.79289C14.8946 1.98043 15 2.23478 15 2.5V5.33333C15 5.51014 14.9298 5.67971 14.8047 5.80474C14.6797 5.92976 14.5101 6 14.3333 6H12V2.5C12 2.23478 12.1054 1.98043 12.2929 1.79289C12.4804 1.60536 12.7348 1.5 13 1.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M13.5 1.5H5C4.46957 1.5 3.96086 1.71071 3.58579 2.08579C3.21071 2.46086 3 2.96957 3 3.5V13.5C3 15.5 2 16.084 1 16.5H9C9.79565 16.5 10.5587 16.1839 11.1213 15.6213C11.6839 15.0587 12 14.2956 12 13.5V6" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>

            `},
      }
    },

    {
      permissions: [],
      path: '/transaction/:id',
      name: 'New Transaction',
      component: NewTransaction,
    },
    {
      permissions: [],
      path: '/officeExclusive',
      name: 'Office Exclusive',
      component:OfficeExclusive,
    },


    // {
    //   permissions: (userpermissionsrole?.some((permission) => permission.id === "investor") === true) ? [] : ["Investor"],
    //   path: '/newtransaction/homewarranty',
    //   name: 'Home Waranty',
    //   component: HomeWarranty,
    //   navItem: {
    //     addLinkClass: 'sub-nav-item',
    //     _tag: 'SidebarItem',
    //     name: 'Home Waranty',

    //   }
    // },
    //    {
    //   permissions: (userpermissionsrole?.some((permission) => permission.id === "investor") === true) ? [] : ["Investor"],
    //   path: '/newtransaction/inspectioncompany',
    //   name: 'Inspection Company',
    //   component: HomeWarranty,
    //   navItem: {
    //     addLinkClass: 'sub-nav-item',
    //     _tag: 'SidebarItem',
    //     name: 'Inspection Company',
    //   }
    // },

    //       {
    //   permissions: (userpermissionsrole?.some((permission) => permission.id === "investor") === true) ? [] : ["Investor"],
    //   path: '/newtransaction/termitecompany',
    //   name: 'Termite Company',
    //   component: HomeWarranty,
    //   navItem: {
    //     addLinkClass: 'sub-nav-item',
    //     _tag: 'SidebarItem',
    //     name: 'Termite Company',
    //   }
    // },
    //       {
    //   permissions: (userpermissionsrole?.some((permission) => permission.id === "investor") === true) ? [] : ["Investor"],
    //   path: '/newtransaction/escrowagent',
    //   name: 'Escrow Agent',
    //   component: HomeWarranty,
    //   navItem: {
    //     addLinkClass: 'sub-nav-item',
    //     _tag: 'SidebarItem',
    //     name: 'Escrow Agent',
    //   }
    // },
    //       {
    //   permissions: (userpermissionsrole?.some((permission) => permission.id === "investor") === true) ? [] : ["inprogress"],
    //   path: '/newtransaction/incompleteOffer',
    //   name: 'Incomplete Offer',
    //   component: IncompleteOffer,
    //   navItem: {
    //     addLinkClass: 'sub-nav-item',
    //     _tag: 'SidebarItem',
    //     name: 'Incomplete Offer',
    //   }
    // },

    {
      permissions: (userpermissionsrole?.some((permission) => permission?.id === "mission") === true) ? [] : ["mission"],
      path: '/mission',
      name: 'Missions',
      component: Mission,
      navItem: {
        _tag: 'SidebarItem',
        name: 'Missions',
        icon: {
          content: `<svg width="62" height="65" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.1914 8.33322V5.54122C15.1912 5.07561 15.0828 4.61642 14.8747 4.19989L14.3034 3.05656C14.2928 3.03599 14.2767 3.01874 14.257 3.0067C14.2372 2.99465 14.2145 2.98828 14.1914 2.98828C14.1683 2.98828 14.1456 2.99465 14.1258 3.0067C14.1061 3.01874 14.09 3.03599 14.0794 3.05656L13.5081 4.19989C13.3 4.61642 13.1916 5.07561 13.1914 5.54122V6.33322" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M1.19141 8.33322V5.54122C1.19158 5.07561 1.29999 4.61642 1.50807 4.19989L2.07941 3.05656C2.09001 3.03599 2.10606 3.01874 2.12582 3.0067C2.14558 2.99465 2.16827 2.98828 2.19141 2.98828C2.21454 2.98828 2.23724 2.99465 2.25699 3.0067C2.27675 3.01874 2.29281 3.03599 2.30341 3.05656L2.87474 4.19989C3.08282 4.61642 3.19123 5.07561 3.19141 5.54122V6.33322" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M7.1875 5.73732C7.319 5.60167 7.47783 5.49551 7.65346 5.42588C7.82909 5.35625 8.01751 5.32475 8.20624 5.33345C8.39496 5.34214 8.57969 5.39085 8.74817 5.47634C8.91665 5.56183 9.06504 5.68215 9.1835 5.82932" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5.86719 3.33203H10.5152" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8.19141 12.832V16.332" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M10.6914 16.332H5.69141L5.19141 5.83203C5.19141 4.17536 6.53474 1.33203 8.19141 1.33203C9.84807 1.33203 11.1914 4.17536 11.1914 5.83203L10.6914 16.332Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M11.0996 7.75195L14.5083 10.7346C14.7227 10.9223 14.8945 11.1537 15.0123 11.4132C15.13 11.6727 15.1909 11.9543 15.1909 12.2393V14.332C15.1909 14.5972 15.0856 14.8515 14.8981 15.0391C14.7105 15.2266 14.4562 15.332 14.1909 15.332H10.7383" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5.28274 7.75195L1.87407 10.7346C1.65966 10.9223 1.48783 11.1537 1.37009 11.4132C1.25236 11.6727 1.19144 11.9543 1.19141 12.2393V14.332C1.19141 14.5972 1.29676 14.8515 1.4843 15.0391C1.67184 15.2266 1.92619 15.332 2.19141 15.332H5.64407" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg> 
            `},
      }
    },

    // Offers
    // {
    //   permissions: (userpermissionsrole?.some((permission) => permission.id === "claimtransaction") === true) ? [] : ["claimtransaction"],
    //   path: '/claim-transaction',
    //   name: 'Claim Transaction',
    //   component: ClaimTransaction,
    //   navItem: {
    //     _tag: 'SidebarItem',
    //     name: 'Marketing',
    //     icon: {
    //       content: `<svg xmlns="http://www.w3.org/2000/svg" width="65" height="65" viewBox="0 0 18 18" fill="none">
    //       <path d="M3.08739 9.53373L3.38605 8.75039L2.68872 6.92106C2.63865 6.78911 2.63515 6.64402 2.6788 6.50981C2.72244 6.3756 2.81062 6.26032 2.92872 6.18306L4.56739 5.11306L5.07872 3.22373C5.11566 3.08747 5.19809 2.96795 5.31233 2.88501C5.42656 2.80206 5.56573 2.76068 5.70672 2.76773L7.66139 2.86706L9.18539 1.63706C9.29538 1.54837 9.43242 1.5 9.57372 1.5C9.71502 1.5 9.85206 1.54837 9.96205 1.63706L11.4861 2.86706L13.4407 2.76973C13.5817 2.76268 13.7209 2.80406 13.8351 2.88701C13.9493 2.96995 14.0318 3.08947 14.0687 3.22573L14.5801 5.11506L16.2187 6.18506C16.3369 6.26223 16.4252 6.37751 16.4688 6.51175C16.5125 6.64599 16.5089 6.79112 16.4587 6.92306L15.7621 8.75239L16.4587 10.5811C16.509 10.7131 16.5125 10.8583 16.4689 10.9927C16.4252 11.127 16.337 11.2424 16.2187 11.3197L14.5801 12.3864L14.0661 14.2764C14.0293 14.4128 13.947 14.5326 13.8327 14.6157C13.7185 14.6988 13.5792 14.7402 13.4381 14.7331L11.4834 14.6357L9.95939 15.8631" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    //       <path d="M11.5807 12.694L2.38337 15.5713L1.7207 14.5273L7.82604 6.7793L11.5807 12.694Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    //       <path d="M4.37109 14.9496L4.95509 15.8469C5.05166 16.0052 5.17956 16.1421 5.33094 16.2492C5.48233 16.3563 5.65401 16.4313 5.83543 16.4697C6.01686 16.508 6.2042 16.5088 6.38597 16.4721C6.56773 16.4354 6.74008 16.362 6.89243 16.2563C7.20388 16.0321 7.41789 15.6974 7.49064 15.3207C7.56338 14.9439 7.48938 14.5536 7.28376 14.2296L7.17509 14.0723" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    //       </svg>`
    //     },
    //     badge: {
    //       text: 45,
    //       color: 'primary'
    //     }
    //   }
    // },

    {
      permissions: (userpermissionsrole?.some((permission) => permission.id === "claimtransaction") === true) ? [] : ["claimtransaction"],
      path: '/claim-transaction',
      name: 'Claim Transaction',
      component: ClaimTransaction,
      navItem: {
        _tag: 'SidebarItem',
        name: 'Claim Transaction',
        icon: {
          content: `<svg width="62" height="65" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 4H6.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5.5 6.5H9.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5.5 9H9.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5.5 11.5H9.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5.5 14H7.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M13 1.5H14C14.2652 1.5 14.5196 1.60536 14.7071 1.79289C14.8946 1.98043 15 2.23478 15 2.5V5.33333C15 5.51014 14.9298 5.67971 14.8047 5.80474C14.6797 5.92976 14.5101 6 14.3333 6H12V2.5C12 2.23478 12.1054 1.98043 12.2929 1.79289C12.4804 1.60536 12.7348 1.5 13 1.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M13.5 1.5H5C4.46957 1.5 3.96086 1.71071 3.58579 2.08579C3.21071 2.46086 3 2.96957 3 3.5V13.5C3 15.5 2 16.084 1 16.5H9C9.79565 16.5 10.5587 16.1839 11.1213 15.6213C11.6839 15.0587 12 14.2956 12 13.5V6" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>`
        },
      }
    },
    
    // Offers
    // {
    //   permissions: (userpermissionsrole?.some((permission) => permission.id === "claimtransaction") === true) ? [] : ["claimtransaction"],
    //   path: '/claim-transaction',
    //   name: 'Claim Transaction',
    //   component: ClaimTransaction,
    //   navItem: {
    //     _tag: 'SidebarItem',
    //     name: 'Offers',
    //     icon: {
    //       content: `<svg xmlns="http://www.w3.org/2000/svg" width="65" height="65" viewBox="0 0 18 18" fill="none">
    //         <path d="M10.086 16.5H2.5C2.23478 16.5 1.98043 16.3946 1.79289 16.2071C1.60536 16.0196 1.5 15.7652 1.5 15.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H15.5C15.7652 1.5 16.0196 1.60536 16.2071 1.79289C16.3946 1.98043 16.5 2.23478 16.5 2.5V10.086C16.4999 10.351 16.3947 10.6052 16.2073 10.7927L10.7927 16.2073C10.6052 16.3947 10.351 16.4999 10.086 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    //         <path d="M10.5 16.41V11.5C10.5 11.2348 10.6054 10.9804 10.7929 10.7929C10.9804 10.6054 11.2348 10.5 11.5 10.5H16.41" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    //         <path d="M5.5 5.5H13.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    //         <path d="M5.5 8.5H9" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    //         </svg>`
    //     },
    //     badge: {
    //       text: 45,
    //       color: 'primary'
    //     }
    //   }
    // },


    // Messages
    // {
    //   permissions: (userpermissionsrole?.some((permission) => permission.id === "claimtransaction") === true) ? [] : ["claimtransaction"],
    //   path: '/claim-transaction',
    //   name: 'Claim Transaction',
    //   component: ClaimTransaction,
    //   navItem: {
    //     _tag: 'SidebarItem',
    //     name: 'Messages',
    //     icon: {
    //       content: `<svg xmlns="http://www.w3.org/2000/svg" width="65" height="66" viewBox="0 0 17 18" fill="none">
    //       <path d="M14.7871 13.5H7.78711L3.78711 16.5V13.5H1.78711C1.5219 13.5 1.26754 13.3947 1.08 13.2071C0.892466 13.0196 0.787109 12.7652 0.787109 12.5V2.5C0.787109 2.23479 0.892466 1.98043 1.08 1.79289C1.26754 1.60536 1.5219 1.5 1.78711 1.5H14.7871C15.0523 1.5 15.3067 1.60536 15.4942 1.79289C15.6818 1.98043 15.7871 2.23479 15.7871 2.5V12.5C15.7871 12.7652 15.6818 13.0196 15.4942 13.2071C15.3067 13.3947 15.0523 13.5 14.7871 13.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    //       <path d="M8.28711 7.75C8.42518 7.75 8.53711 7.63807 8.53711 7.5C8.53711 7.36193 8.42518 7.25 8.28711 7.25" stroke="black" stroke-width="1.5"/>
    //       <path d="M5.28711 7.75C5.42518 7.75 5.53711 7.63807 5.53711 7.5C5.53711 7.36193 5.42518 7.25 5.28711 7.25" stroke="black" stroke-width="1.5"/>
    //       <path d="M11.2871 7.75C11.149 7.75 11.0371 7.63807 11.0371 7.5C11.0371 7.36193 11.149 7.25 11.2871 7.25" stroke="black" stroke-width="1.5"/>
    //       <path d="M11.2871 7.75C11.4252 7.75 11.5371 7.63807 11.5371 7.5C11.5371 7.36193 11.4252 7.25 11.2871 7.25" stroke="black" stroke-width="1.5"/>
    //       </svg>`
    //     },
    //     badge: {
    //       text: 45,
    //       color: 'primary'
    //     }
    //   }
    // },

    // Phone calls
    // {
    //   permissions: (userpermissionsrole?.some((permission) => permission.id === "claimtransaction") === true) ? [] : ["claimtransaction"],
    //   path: '/claim-transaction',
    //   name: 'Claim Transaction',
    //   component: ClaimTransaction,
    //   navItem: {
    //     _tag: 'SidebarItem',
    //     name: 'Phone Calls',
    //     icon: {
    //       content: `<svg xmlns="http://www.w3.org/2000/svg" width="65" height="65" viewBox="0 0 18 18" fill="none">
    //       <path d="M11.1319 16.0674L11.1399 16.072C11.848 16.5228 12.6887 16.7187 13.5231 16.6271C14.3575 16.5356 15.1357 16.1623 15.7293 15.5687L16.2453 15.0527C16.4757 14.822 16.6052 14.5092 16.6052 14.183C16.6052 13.8569 16.4757 13.5441 16.2453 13.3134L14.0713 11.1407C13.8405 10.9102 13.5277 10.7808 13.2016 10.7808C12.8755 10.7808 12.5627 10.9102 12.3319 11.1407C12.2178 11.255 12.0823 11.3456 11.9332 11.4074C11.784 11.4693 11.6241 11.5011 11.4626 11.5011C11.3011 11.5011 11.1412 11.4693 10.9921 11.4074C10.8429 11.3456 10.7074 11.255 10.5933 11.1407L7.11461 7.66137C6.88415 7.43062 6.7547 7.11783 6.7547 6.7917C6.7547 6.46558 6.88415 6.15279 7.11461 5.92204C7.22886 5.80792 7.3195 5.67241 7.38134 5.52324C7.44319 5.37408 7.47502 5.21418 7.47502 5.0527C7.47502 4.89122 7.44319 4.73133 7.38134 4.58216C7.3195 4.433 7.22886 4.29748 7.11461 4.18337L4.94128 2.00737C4.71053 1.77691 4.39774 1.64746 4.07161 1.64746C3.74549 1.64746 3.4327 1.77691 3.20195 2.00737L2.68595 2.52337C2.0925 3.11696 1.71915 3.89513 1.62753 4.72948C1.5359 5.56382 1.73146 6.40447 2.18195 7.1127L2.18728 7.1207C4.56955 10.6473 7.60593 13.6843 11.1319 16.0674Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    //       </svg>`
    //     },
    //     badge: {
    //       text: 45,
    //       color: 'primary'
    //     }
    //   }
    // },

    // Video calls
    // {
    //   permissions: (userpermissionsrole?.some((permission) => permission.id === "claimtransaction") === true) ? [] : ["claimtransaction"],
    //   path: '/claim-transaction',
    //   name: 'Claim Transaction',
    //   component: ClaimTransaction,
    //   navItem: {
    //     _tag: 'SidebarItem',
    //     name: 'Video Calls',
    //     icon: {
    //       content: `<svg xmlns="http://www.w3.org/2000/svg" width="65" height="66" viewBox="0 0 16 17" fill="none">
    //       <path d="M12.0156 6.6543L10.0156 7.32096V6.6543C10.0156 6.38908 9.91027 6.13473 9.72273 5.94719C9.5352 5.75965 9.28084 5.6543 9.01563 5.6543H5.01563C4.75041 5.6543 4.49605 5.75965 4.30852 5.94719C4.12098 6.13473 4.01562 6.38908 4.01562 6.6543V10.6543C4.01562 10.9195 4.12098 11.1739 4.30852 11.3614C4.49605 11.5489 4.75041 11.6543 5.01563 11.6543H9.01563C9.28084 11.6543 9.5352 11.5489 9.72273 11.3614C9.91027 11.1739 10.0156 10.9195 10.0156 10.6543V9.98763L12.0156 10.6543V6.6543Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    //       <path d="M4.01562 1.6543H12.0156C12.0156 1.6543 15.0156 1.6543 15.0156 4.6543V12.6543C15.0156 12.6543 15.0156 15.6543 12.0156 15.6543H4.01562C4.01562 15.6543 1.01562 15.6543 1.01562 12.6543V4.6543C1.01562 4.6543 1.01562 1.6543 4.01562 1.6543Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    //       </svg>`
    //     },
    //     badge: {
    //       text: 45,
    //       color: 'primary'
    //     }
    //   }
    // },
    
    // What's New
    // {
    //   permissions: (userpermissionsrole?.some((permission) => permission.id === "claimtransaction") === true) ? [] : ["whatsnew"],
    //   path: '/whats-new',
    //   name: 'whatsnew',
    //   component: ClaimTransaction,
    //   navItem: {
    //     _tag: 'WhatsNew',
    //     name: "What's New",
    //     icon: {
    //       content: `<svg xmlns="http://www.w3.org/2000/svg" width="65" height="65" viewBox="0 0 16 16" fill="none">
    //                 <g clip-path="url(#clip0_5119_21018)">
    //                 <path d="M0.5 6V10" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    //                 <path d="M15.5 1V15" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    //                 <path d="M0.5 7L15.5 2" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    //                 <path d="M0.5 9L15.5 14" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    //                 <path d="M3.41797 9.97266V9.99999C3.44641 10.9172 3.75624 11.8034 4.30543 12.5386C4.85463 13.2737 5.61662 13.8222 6.48809 14.1096C7.35955 14.397 8.29832 14.4095 9.1771 14.1453C10.0559 13.881 10.8321 13.353 11.4006 12.6327" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    //                 </g>
    //                 <defs>
    //                 <clipPath id="clip0_5119_21018">
    //                 <rect width="16" height="16" fill="white"/>
    //                 </clipPath>
    //                 </defs>
    //                 </svg>`
    //     },
    //   }
    // },
    { permissions: [], path: '/createnewpassword', name: 'Createnewpassword', component: Createnewpassword, navItem: null },
    { permissions: [], path: '/verifyidentity', name: 'VerifyIdentity', component: VerifyIdentity, navItem: null },
    { permissions: [], path: '/singleproduct', name: 'SingleProduct', component: SingleProduct, navItem: null },
    { permissions: [], path: '/Maps', name: 'commute', component: Maps, navItem: null },

    { permissions: [], path: '/property-list', name: 'Profile', component: Home, navItem: null },
    { permissions: [], path: '/property-list/clientprofile', name: 'Profile', component: Profile, navItem: null },
    { permissions: [], path: '/property-list/favourites', name: 'Favourites', component: Favorites, navItem: null },
    { permissions: [], path: '/property-list/dislike', name: 'dislke', component: Dislikes, navItem: null },
    { permissions: [], path: '/property-list/:id/similar', name: 'similar', component: ViewSimilarProperties, navItem: null },
    { permissions: [], path: '/property-list/recentlyviewed', name: 'recentlyviewed', component: RecentlyViewed, navItem: null },
    { permissions: [], path: '/property-list/account', name: 'account', component: Accounts, navItem: null },
    { permissions: [], path: '/property-list/accountsetting', name: 'accountsettings', component: AccountSettings, navItem: null },
    { permissions: [], path: '/property-list/yourteam', name: 'your team', component: Team, navItem: null },
    { permissions: [], path: '/property-list/savedlists', name: 'saved list', component: SavedList, navItem: null },
    { permissions: [], path: '/property-list/savedlists/items', name: 'saved list items', component: savedlistitems, navItem: null },
    { permissions: [], path: '/property-list/refferal', name: 'Profile', component: Refferal, navItem: null },
    { permissions: [], path: '/property-list/submitreferal', name: 'Profile', component: SubmitReferals, navItem: null },
    { permissions: [], path: '/property-list/teamprofile', name: 'Profile', component: Teamprofile, navItem: null },
    { permissions: [], path: '/property-list/myreferal', name: 'Profile', component: MyReffral, navItem: null },
    { permissions: [], path: '/property-list/messages', name: 'Profile', component: Messages, navItem: null },
    { permissions: [], path: '/property-list/composenewmessages', name: 'Profile', component: ComposeNewMessages, navItem: null },
    { permissions: [], path: '/property-list/chatview', name: 'Profile', component: ChatView, navItem: null },
  ]


  return route
}

export const useNavigation = () => {
  const dispatch = useDispatch()
  dispatch(claimcount(25))
  const state = useSelector((v:any)=>v.claimcontact.Nocount)

  const[coll,setColl] = useState(false)
  let userpermissionsroledata = userPermissionRole();
  const [mainRoutes, setMainRoutes] = useState<any>([])

  let res = async()=> {
    return await localStorage.getItem('collapse')
  }

  const handleCollapse = () => {
    collapse()
    setMainRoutes((prev) => {
      let copy = [...prev]
      copy = copy.map((item) => {
        if (item?.navItem && "hidden" in item?.navItem) {
          item.navItem.hidden = !item.navItem.hidden;
          localStorage.setItem('collapse',item.navItem.hidden)
        }
        return item
      })
      return copy
    })
  }

  async function collapse() {
      
    let res1:any =await res()
    setColl(res1)
  }
  useEffect(() => {
   
    setMainRoutes(() => {
      return routing().map((item) => {
        if (item?.path === "/leads") {
          item.navItem.onClick = () => {
            handleCollapse()
          }
       
        }
        return item
      })
    })
  }, [])
  

  return mainRoutes.filter((v) => v.navItem)
    .filter((v) => v.permissions?.length === 0 || v.permissions?.find((x) => userpermissionsroledata && userpermissionsroledata?.find((v) => v?.permission === x)))
    .map((v) => ({ ...v.navItem, to: v.path }))
    .filter((item) => {
      if ("hidden" in item) {
        return !item.hidden
      }
      return true
    })
}

let routes = routing();

export default routes    
